module.exports = __webpack_public_path__ + "static/img/10.644b2a52.png";